import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';


import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';
import Dropdown from '../Dropdown';


import DatePicker from '../DatePicker';

import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";
import { registrationRequest, loginReset } from '../../../redux/reducers/login';
import { COLORS,commonStyles } from '../../../styles/styles';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';





const SecondPageModal = ({ classes, form, pristine, previousPage, submitting,login, ...props }) => {
  
  const { handleSubmit, dropdowns, checkCode } = props;
 
  return (
<form className="w-100"  onSubmit={handleSubmit}>
    <MDBCol md="12">
    <MDBRow>
      <MDBCol md="12">
      <Field name="employeeNo" label="Employee Number" component={TextField}  />
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="12">
      <Field name="positionHeld" label="Position Held " component={TextField}  />
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="12">
      <Field name="businessUnit" label="Business Unit (Optional)" component={TextField}  />
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="12">
      {dropdowns.dropdowns.branches && <Field name="conBranch" label="Branch" component={Dropdown}  options={dropdowns.dropdowns.branches}  depth={10008}/>}
      </MDBCol>

    </MDBRow>
    <MDBRow>
      <MDBCol md="12">
      {dropdowns.dropdowns.regions && <Field name="conRegion" label="Region" component={Dropdown}   options={dropdowns.dropdowns.regions}  depth={10007}/>}
      </MDBCol>
  
    </MDBRow>
    <MDBRow>
      <MDBCol md="12">
      {dropdowns.dropdowns.countries && <Field name="conCountryID" label="Country" component={Dropdown}  options={dropdowns.dropdowns.countries}  depth={10006}/>}
      </MDBCol>
  
    </MDBRow>
    <MDBRow className="mt-4">
        <MDBCol size="6">
         
        </MDBCol>
        <MDBCol size="6">
          <MDBBtn color="success"
              right
              size="md"
              className='ml-3 mr-2 mt-0 mb-2 float-right'
              action
              type="submit">
            NEXT
          </MDBBtn>
        </MDBCol>
      </MDBRow>

  </MDBCol>
  <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{login.fetchingPageReg && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
        color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
 
  </form>
    
    
  ) 
}



SecondPageModal.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
  checkCode: state.checkCodeReducer,
  initialValues: state.loginReducer.user.extendedInfo
});
const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  loginReset: () => dispatch(loginReset()),
});




const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '5px',
  },
  label: {
    color: '#e84848',
  },
  dropdown:{
    border:'20px solid red'
    //borderRadius: '0 !important'
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  },
});

export default compose(
  reduxForm({ form: 'registration',
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,
  enableReinitialize : true,   
  validate
 }),
  connect(mapStateToProps, mapDispatchToProps),
  
  withStyles(styles),
  lifecycle({
    componentWillMount() {
   
      // if(this.props.dropdowns.dropdowns.branches!=nextProps.dropdowns.dropdowns.branches){
        
        var obj = {};
        obj.employeeNo = this.props.initialValues.EmployeeNo;
        obj.positionHeld = this.props.initialValues.PositionHeld
        obj.businessUnit = this.props.initialValues.BusinessUnit
        obj.conBranch = this.props.initialValues.conClientBranchID
        obj.conRegion = this.props.initialValues.conClientRegionID
        obj.conCountryID = this.props.initialValues.conCountryID
        
        this.props.initialize(obj)
    //}
      
    }
  }),
)(SecondPageModal);
